import { render, staticRenderFns } from "./IndirectServicesForm.vue?vue&type=template&id=af668c94"
import script from "./IndirectServicesForm.vue?vue&type=script&lang=js"
export * from "./IndirectServicesForm.vue?vue&type=script&lang=js"
import style0 from "./IndirectServicesForm.vue?vue&type=style&index=0&id=af668c94&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports